import { ViewBooking, ViewCustomer } from "collins-js-sdk";
import {
  BookingLabel,
  CustomerLabel,
  VenueGroupConfig
} from "../../../../../types/VenueGroup";
import { VenueConfig } from "../../../../../types/venues";

export const linkedBookingLabel: BookingLabel = {
  id: "linked_booking",
  label: "Linked Booking",
  colour: "929396"
};

export const autoConfirmedLabel: BookingLabel = {
  id: "auto_confirmed",
  label: "Auto Confirmed",
  colour: "929396"
};

export const allergyLabel: CustomerLabel = {
  colour: "929396",
  id: "allergy",
  label: "Allergy",
  type: ""
};

type GetBookingLabelsProps = {
  venueConfig: VenueConfig;
  venueGroupConfig: VenueGroupConfig;
};
export const getAllBookingLabels = ({
  venueConfig,
  venueGroupConfig
}: GetBookingLabelsProps) => {
  const extraLabels = [linkedBookingLabel, autoConfirmedLabel];
  let labels = venueGroupConfig.booking_labels ?? [];
  if (venueConfig.override_booking_labels) {
    labels = venueConfig.booking_labels ?? [];
  }

  return labels.concat(extraLabels);
};

type GetCustomerLabelsProps = {
  venueConfig: VenueConfig;
  venueGroupConfig: VenueGroupConfig;
};
export const getAllCustomerLabels = ({
  venueConfig,
  venueGroupConfig
}: GetCustomerLabelsProps) => {
  const extraLabels = [allergyLabel];
  let labels = venueGroupConfig.customer_labels ?? [];
  if (venueConfig.override_customer_labels) {
    labels = venueConfig.customer_labels ?? [];
  }

  return labels.concat(extraLabels);
};

type getBookingLabelsType = {
  venueConfig: VenueConfig;
  venueGroupConfig: VenueGroupConfig;
  selectedBooking: ViewBooking;
};
export const getSelectedBookingLabels = ({
  venueConfig,
  venueGroupConfig,
  selectedBooking
}: getBookingLabelsType): BookingLabel[] => {
  const availableLabels = getAllBookingLabels({
    venueConfig,
    venueGroupConfig
  });

  return (
    availableLabels.filter((bookingLabel) =>
      selectedBooking.labels?.includes(bookingLabel.id)
    ) ?? []
  );
};

type getCustomerLabelsType = {
  venueConfig: VenueConfig;
  venueGroupConfig: VenueGroupConfig;
  selectedCustomer: ViewCustomer;
};
export const getSelectedCustomerLabels = ({
  venueConfig,
  venueGroupConfig,
  selectedCustomer
}: getCustomerLabelsType): CustomerLabel[] => {
  const availableLabels = getAllCustomerLabels({
    venueConfig,
    venueGroupConfig
  });

  return (
    availableLabels.filter((bookingLabel) =>
      selectedCustomer.labels?.includes(bookingLabel.id)
    ) ?? []
  );
};
